import { MouseEvent, useState } from "react";

import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";

import { TCourseDocument } from "../../../../../@types";

export type TCourseDocumentVideoProps = {
	file: TCourseDocument;
	onRemoveFile: (id: number) => void;
};

export function CloudCourseDocumentVideo({
	file,
	onRemoveFile,
}: TCourseDocumentVideoProps) {
	const [isLoading, setIsLoading] = useState(true);

	const onLoad = () => {
		setIsLoading(false);
	};

	const onClickRemoveFile = (
		e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
	) => {
		e.stopPropagation();
		if (file.id) {
			onRemoveFile(file.id);
		}
	};

	return (
		<div className="media-container">
			<video className="media" onLoadedMetadata={onLoad} playsInline>
				<source src={file.url} type="video/mp4" />
			</video>
			{isLoading && (
				<Box sx={{ position: "absolute", zIndex: 1, display: "inline-flex" }}>
					<CircularProgress />
				</Box>
			)}
			<Tooltip title="Remove">
				<IconButton className="remove-button" onClick={onClickRemoveFile}>
					<IoClose />
				</IconButton>
			</Tooltip>
		</div>
	);
}
